import { createAsyncThunk } from "@reduxjs/toolkit";
import { reviewApi } from "./review.wpapi";

export const fetchPressReviews = createAsyncThunk("review/get", async () => {
  const response = await reviewApi();
  return response;
});
